<template>
  <div class="header-element" id="header-element scrolled">

    <span class="header-logo">
      <img  class="header-logo-img" src="../../../assets/winter-2019/mikmak-gradient-logo-2.png" alt="mikmak.tv" v-on:click="goHome">
    </span>

    <span class="header-items">

      <span class="header-links" v-bind:class="[ mobileMenuVisible ? 'mobile-menu-links-visible' : 'mobile-menu-links-hidden' ]">

        <label class="link-label">
          <a :href="getLink('#our-software')" v-on:click="mobileMenuVisible = false">Software</a>
        </label>

        <label class="link-label">
          <a :href="getLink('#our-solutions')" v-on:click="mobileMenuVisible = false">Solutions</a>
        </label>

        <label class="link-label">
          <a :href="getLink('#our-services')" v-on:click="mobileMenuVisible = false">Services</a>
        </label>

        <label class="link-label">
          <a :href="getLink('careers')" v-on:click="mobileMenuVisible = false">Careers</a>
        </label>

        <label class="link-label">
          <a :href="getLink('about')" v-on:click="mobileMenuVisible = false">About</a>
        </label>

        <!-- Software, Solutions, Studios, Academy, About (or Product, Case Studies, Jobs, About) -->

      </span>

      <a href="#contact-footer" class="header-contact" v-on:click="getDemoEvent()">
        Contact
      </a>

      <span class="header-menu-bars" v-bind:class="[ mobileMenuVisible ? 'mobile-menu-visible' : 'mobile-menu-hidden' ]" v-on:click="mobileMenuVisible = !mobileMenuVisible">
        <label class="header-menu-bar header-menu-bar-left"></label>
        <label class="header-menu-bar header-menu-bar-right"></label>
      </span>

    </span>

    <a href="#contact-footer" class="get-demo-fixed-mobile" v-bind:class="[ showGetDemo ? 'get-demo-visible' : 'get-demo-hidden']">
      Get a Demo
    </a>

  </div>
</template>

<script>

const scrollListener = () => {
  if (window.pageYOffset >= 0) {
    setHeaderClass('header-element scrolled')
  } else {
    setHeaderClass('header-element')
  }
}

const setHeaderClass = (className) => {
  let header = document.getElementById('header-element')
  if (header) header.className = className
}

import eventDispatcher from '../../../events/dispatch'

export default {
  data() {
    return {
      mobileMenuVisible: false,
      showGetDemo: false
    }
  },
  mounted() {
    window.document.onscroll = scrollListener

    if (this.$route.name == 'HomePage') this.scrollListener()
  },
  methods: {
    getDemoEvent() {
      eventDispatcher('requestDemoClicked', {
        sourceOfDemo: 'Contact Button in header bar'
      })
    },
    goHome() {
      window.location = '/'
    },
    getLink(link) {
      return `${window.location.origin}/${link}`
    },
    scrollListener() {
      let self = this
      $(window).scroll(function(){
        let scrollTop = $(window).scrollTop()
        if (scrollTop > 1200 && scrollTop < 4500) {
          self.showGetDemo = true
        } else {
          self.showGetDemo = false
        }
      });
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

.header-element {
  text-align: left;
  font-size: 16px;
  padding: 8px 16px;
  display: block;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 10;
  transition: ease-in 0.125s;
  white-space: nowrap;
  min-height: 40px;
}

@media only screen and (max-width: 2250px) {
  .header-element,
  .header-element.scrolled {
    box-shadow: 0 2px 2px rgba(0,0,0,.09);
    background: white;
  }
}

.header-element.scrolled {
  box-shadow: 0 2px 2px rgba(0,0,0,.09);
  background: white;
}

.header-contact {
  display: inline-block;
  background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
  color: white;
  cursor: pointer;
  padding: 6px 16px;
  margin-top: -24px;
  vertical-align: middle;
  border-radius: 2px;
  border: none;
  transition: ease-in-out 0.225s;
  text-decoration: none;
}

@media only screen and (max-width: 1250px) {
  .header-contact {
    display: inline-block;
  }
}

@media only screen and (max-width: 800px) {
  .header-items,
  .header-logo {
    width: 50%;
    display: inline-block;
  }

  .header-items {
    text-align: right;
  }

}

.header-contact:hover {
  /* color: #31c4a8 !important; */
  /* background: #31c4a8 !important; */
}

.header-element.scrolled .header-contact {
  display: inline-block;
}

.header-logo {
  cursor: pointer;
}

.header-logo-img {
  width: 90px;
}

.link-label {
  display: inline-block;
  vertical-align: top;
}

.header-links {
  transition: ease-in-out 250ms;
  display: inline-block;
  vertical-align: top;
  font-family: "Vaud", -apple-system, BlinkMacSystemFont, "Avenir Next", "Avenir", "Segoe UI", "Lucida Grande", "Helvetica Neue", "Helvetica", "Fira Sans", "Roboto", "Noto", "Droid Sans", "Cantarell", "Oxygen", "Ubuntu", "Franklin Gothic Medium", "Century Gothic", "Liberation Sans", sans-serif;
  font-size: 16px;
  letter-spacing: -0.01px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
  margin-top: 10px;
  width: 80%;
  text-align: center;
}

@media only screen and (max-width: 800px) {

  .header-links {
    z-index: 1;
    position: fixed;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: white;
    white-space: normal;
    display: block;
  }

  .mobile-menu-links-visible {
    top: 40px;
  }

  .mobile-menu-links-hidden {
    top: 4000px;
  }

  .link-label {
    display: block;
  }

  .header-links a {
    display: block;
    margin: 60px auto;
    margin-right: 0px !important;
    padding: 0px;
    height: auto !important;
    font-size: 24px;
  }
}

.header-links a {
  color: #1D2229 !important;
  text-decoration: none;
  color: inherit;
  margin-right: 24px;
  height: 92px;
  align-items: center;
  transform: translateY(1px);
  transition: color ease-in-out 150ms;
  letter-spacing: .5px;
}

.header-links a:hover {
  color: #31c4a8 !important;
  outline: none;
}

.mobile-menu-visible {

}

.mobile-menu-hidden {

}

.header-menu-bars {
  display: none;
}

@media only screen and (max-width: 800px) {
  .header-menu-bars {
    display: inline-block;
    margin-left: 24px;
  }
}

.header-menu-bar {
  transition: ease-in-out 250ms;
  display: block;
  background: black;
  height: 3px;
  width: 32px;
  margin-bottom: 8px;
}

.mobile-menu-visible .header-menu-bar-left {
  transform: rotate(45deg);
  margin-bottom: -3px;
}

.mobile-menu-visible .header-menu-bar-right {
  transform: rotate(-45deg);
  margin-bottom: 13px;
}

.get-demo-fixed-mobile {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
  color: white;
  padding: 24px;
  transition: ease-in-out 0.225s;
  text-align: center;
  font-family: "Work Sans", sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 20px;
  text-decoration: none;
}

@media only screen and (max-width: 550px) {
  .get-demo-fixed-mobile {
    display: block;
  }
}

.get-demo-hidden {
  bottom: -400px;
}

.get-demo-visible {
  bottom: 0px;
}

</style>



// WEBPACK FOOTER //
// Header.vue?8f2392d2